import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {PaymentMethodConfig} from '../models/payment-method-config.model';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodConfigService {

  private readonly ENDPOINT_URL: string = `${environment.apiUrl}/payment-methods`;

  constructor(private http: HttpClient) {
  }

  public getAll(): Observable<PaymentMethodConfig[]> {
    return this.http.get<any[]>(this.ENDPOINT_URL).pipe(
      map(methods => methods.map(m => ({
        id: m.id,
        code: m.code,
        name: m.displayName,
        logoUrl: this.resolveIconUrl(m.icon)
      })))
    );
  }

  private resolveIconUrl(icon: string): string {
    if (!icon || icon.startsWith('http')) {
      return icon;
    }
    return `${environment.apiUrl}${icon}`;
  }

}
